import { SocialLinksPlacementEnum } from "@/scripts/common/enums.js";

export default {
    computed: {
        noMobileClass() {
            return this.inline ? "no-mob" : "";
        },
        navOpenClass() {
            return this.viewData?.navOpen ? "on" : "";
        },
        filteredPages() {
            const pages = Array.isArray(this.allPagesForNavigation) ? this.allPagesForNavigation : [];
            const activePages = pages.filter((page) => !page.deletedAt);
            if (!this.hideHome) return activePages;
            return activePages.filter((page) => page?.shortId !== "home");
        },
        showSocialLinks() {
            const links = this.socialLinksForNavigation;
            return this.navigation?.socialLinks?.position === SocialLinksPlacementEnum.NAVBAR
                && Array.isArray(links)
                && links.length > 0;
        },
    },
};
